import {
  AssemblyType,
  AssemblyTypeKey,
  AssemblyTypeValue,
  JobFormDataInput,
} from '@ecosconnect/core/src/types/jobFormData';
import { gql, useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { AssemblyInfo } from '../components/BackflowTest/types';

const GET_MODEL_INFO = gql`
  query GetAssemblyModel($id: Int) {
    backflowAssemblyModels(where: { id: $id }) {
      id
      name
      backflowAssemblyMake {
        id
        name
      }
    }
  }
`;

const useFormAssembly = (
  formData?: JobFormDataInput,
  backflowAssembly?: AssemblyInfo
): AssemblyInfo | undefined => {
  const { loading: modelLoading, data: modelData } = useQuery<{
    backflowAssemblyModels: any[];
  }>(GET_MODEL_INFO, {
    skip: formData?.installationStatus === 3 || !formData?.backflowAssembly,
    variables: { id: formData?.backflowAssembly?.modelId },
  });

  return useMemo(() => {
    if (formData?.installationStatus === 3 || modelLoading) {
      return undefined;
    }

    if (!formData?.backflowAssembly) {
      return backflowAssembly;
    }

    const model = modelData?.backflowAssemblyModels?.[0];
    let type = undefined as AssemblyTypeKey | undefined;
    if (formData.backflowAssembly.type) {
      for (type in AssemblyType) {
        if (
          type &&
          AssemblyType[type] ===
            (formData.backflowAssembly.type as AssemblyTypeValue)
        )
          break;
      }
    }

    return {
      ...formData.backflowAssembly,
      type,
      model,
      size: formData.backflowAssembly.size
        ? typeof formData.backflowAssembly.size === 'string'
          ? parseFloat(formData.backflowAssembly.size)
          : formData.backflowAssembly.size
        : undefined,
    } as AssemblyInfo;
  }, [
    formData?.installationStatus,
    modelLoading,
    modelData,
    formData?.backflowAssembly,
    backflowAssembly,
  ]);
};

export default useFormAssembly;
